export default {
  // 全局設置
  globalSettings: {
    roleAuthInfo:
      '角色權限控制用戶可以使用哪些模塊、功能以及可查看的數據權限; 角色請在【角色管理】中去創建',
    dataAuth: '數據權限',
    funAuth: '功能權限',
    seeMyData: '僅查看本人數據',
    seeMyDepartment: '查看本部門數據',
    seeCompanyData: '查看全機構數據',
    conteneUpdateIsSave: '內容有更新, 是否需要保存?',
    pageAuthInfo: '顯示機構所有角色, 通過角色查看不同業務類型數據時所使用的頁面布局',
    dataShareInfo: '將符合某壹條件的數據集作為壹個數據區域自動共享給某壹角色、成員、組織架構',
    dataShare: '數據共享',
    ruleContion: '規則條件',
    anyContion: '任何條件',
    zhidingContion: '指定條件',
    matchContion: '選擇匹配條件',
    shareTarget: '共享目標',
    VisitRule: '訪問權限',
    selectSharer: '請選擇分享人',
    delRuleIsGoon: '此操作將永久刪除該規則, 是否繼續?',
    recordLockingInfo: '將符合某壹條件的數據自動鎖定',
    lockingRecordAfter: '鎖定紀錄後',
    recordLocking: '記錄鎖定',
    dontEdit: '不可編輯',
    dontShare: '不可共享',
    dontTransPer: '不可轉移負責人',
    dontZhuanhuan: '不可轉換',
    dontDel: '不可刪除',
    referenceMappingInfo:
      '應用於“關聯關系”類型字段, 設置關聯關系可以將關聯字段模塊中的字段內容依賴到當前模塊中',
    controlField: '控制字段',
    firstControlField: '一级控制字段',
    secondControlField: '二级控制字段',
    referenceMapping: '關聯映射',
    mappingField: '映射字段',
    duiyingField: '對應字段',
    addIsRepeatEdit: '新增的規則已經存在, 請使用編輯功能',
    controlFielNotEmpty: '控制字段不能為空',
    firstControlFielNotEmpty: '壹級控制字段不能為空',
    secondControlFielNotEmpty: '二級控制字段不能為空',
    controlFieldDontSame: '壹級控制字段和二級控制字段不可一致',
    mapDuiyingFieldNotEmpey: '映射字段、對應字段均不能為空',
    mapDelIsgoon: '此操作將永久刪除, 是否繼續?',
    referenceYilaiInfo: '應用於為“關聯關系”類型的字段, 實現兩個關聯關系之間的數據過濾',
    yilaiField: '依賴字段',
    referenceYilai: '關聯依賴',
    controlAndYilaiField: '控制字段和依賴字段不可相互控制和依賴',
    yilaiFieldNotEmpty: '依賴字段不能為空',
    controlAndYilaiDontLike: '控制字段和依賴字段不可壹致',
    controlAndControl2DontLike: '壹級控制選項和二級控制選項不可壹致',
    optionFieldYilaiInfo: '應用於“下拉選項”類型字段, 選擇壹個控制字段和壹個依賴字段進行過濾依賴',
    optionYilai: '選項依賴',
    optionFieldYilai: '選項字段依賴',
    controlOption: '控制選項',
    firstControlOption: '壹級控制選項',
    secondControlOption: '二級控制選項',
    yilaiOption: '依賴選項',
    optionControlInfo: '應用於“下拉選項”類型字段, 通過選項控制下面字段是否顯示',
    optionControl: '選項控制',
    option: '選項',
    referenceField: '關聯字段',
    checkedReferenceShow: '勾選後關聯顯示',
    pleaseSelectOptionList: '請先選擇選項字段的下拉選項',
    pleaseSelectControlList: '請先選擇控制字段的下拉選項',
    dataLinkageInfo: '對已有的表單數據進行預計算(預處理), 以備進壹步調用',
    linkageForm: '聯動表單',
    linkageContion: '聯動條件',
    linkageField: '聯動字段',
    dataLinkage: '數據聯動',
    triggerLinkageField: '觸發聯動字段',
    thisModule: '本模塊',
    valueEqualTo: '的值等於',
    valueTime: '的值時',
    value: '的值',
    linkageShow: '聯動顯示',
    linkageFormNotEmpty: '聯動表單不能為空',
    linkageContionNotEmpty: '聯動條件不能為空',
    linkageFieldNotEmpty: '聯動字段不能為空',
    subformOptionMappingInfo:
      '應用於“主子表關聯映射”, 在子表單中生成按鈕, 通過主表關聯過濾後將子表單數據批量插入',
    subformOptionMapping: '子表單選項映射',
    thisModuleSubform: '本模塊子表單',
    referenceSubform: '關聯子表單',
    filterContion: '過濾條件',
    addFilterContion: '添加過濾條件',
    subformMappingGuanxi: '子表單映射關系',
    selectSubfrom1: '請選擇本模塊子表單',
    selectSubfrom2: '請選擇關聯子表單',
    fieldTransfer: '字段轉換',
    fieldTransferInfo: '將字段轉換到對應的其他模塊中, 再轉換時將使用這些映射',
    addFieldTransfer: '新增字段轉換',
    baseInfo: '基礎信息',
    sourceModule: '源模塊',
    targetModule: '目標模塊',
    jumpSystem: '跳轉鏈接',
    isJumpPolaris: '是否跳轉北極星',
    jump: '跳轉',
    notJump: '不跳轉',
    polarisLink: '北極星鏈接',
    pleaseInputPolarisLink: '請輸入北極星鏈接',
    ifDelSourceRecord: '是否刪除原有記錄?',
    fieldDuiyingGuanxi: '字段對應關系',
    selectSubfrom: '選擇子表單',
    selectTransferTargetModule: '請選擇轉換的目標模塊',
    cancelDel: '已取消刪除',
    autoMarkColor: '自動標記顏色',
    autoMarkColorInfo: '將符合某壹條件的數據自動標記顏色。',
    markColor: '標記顏色',
    showColor: '顯示顏色',
    customPrint: '自定義打印',
    customPrintInfo: '打印模塊數據時可選擇設置好的模板格式進行打印',
    templateName: '模板名稱',
    type: '類型',
    uploadTemplate: '上傳模版',
    addFile: '添加文件',
    exportTemplate: '導出模板',
    exampleTemplateDown: '示例模版下載',
    printTemplate: '打印模版',
    uploadXlsFile: '請上傳 xls 類型文件',
    uploadDocxFile: '請上傳 docx 類型文件',
    uploadPrintTemplate: '請上傳打印模版',
    delTemplateIsGoon: '此操作將永久刪除該模版, 是否繼續?',
    outLink: '數據外鏈',
    outLinkInfo: '將數據發布為獨立的公開鏈接, 無需登錄即可訪問數據',
    openOutLink: '開啟數據外鏈',
    dataVisitAuth: '數據訪問權限',
    openVisit: '公開訪問',
    pwdVisit: '憑密碼訪問',
    fieldVisitAuth: '字段訪問權限',
    setDataOutLink: '設置外鏈字段',
    dataInnerLink: '數據內鏈',
    openDataInnerLinkInfo: '開啟數據內鏈, 通過平台移動端掃壹掃功能可直接訪問數據',
    openDataInnerLink: '開啟數據內鏈',
    sameFieldOutLink: '可以將本模塊哪些字段可以數據外鏈',
    fieldName: '字段名稱',
    accessible: '可訪問',
    selectVisitField: '選擇可訪問字段',
    setPwd: '設置密碼',
    submitCheck: '提交校驗',
    tipsText: '提示文字',
    shortmessageTemplate: '短信模版',
    shortmessageTemplateInfo: '設置字段值的校驗規則, 防止不規範的數據錄入。',
    addTemplate: '新建模版',
    templateContent: '模版內容',
    failBeacuse: '失敗原因',
    shortMessTem25: '請輸入名稱，不得超過25個漢字',
    selsectSigntrue: '選擇簽名',
    pleaseSelsectSigntrue: '請選擇簽名',
    insertVar: '插入變量',
    tamplateNameRequried: '模板名稱必填',
    tamplateContentRequried: '模板內容必填',
    applicationNotesRequried: '申請說明必填',
    tamplateSigntrueRequried: '模板簽名必填',
    applicationNotes: '申請說明',
    shortmessTemMsg1: '請簡略描述您的業務場景, 不超過100字',
    shortmessTemMsg2:
      '共19個字（含簽名和括號）, 1條短信（因含有變量，按實際發送長度計費; 70字以內（含70字）計為1條, 超過70字按67/字1條計費）',
    shortmessTemMsg3: '短信模板需要進行審核, 審核工作時間：周壹至周日 9:00-23:00 （法定節日順延）',
    fieldIsNotInputAgain: '字段不存在, 請重新調整模板內容',
    sureDelShorMesTemplate: '確認要刪除該短信模版嗎?',
    delSuccessDontHuifu: '刪除成功之後, 該操作將無法恢復',
    subMenu: '子菜單',
    subMenuInfo: '對已創建的自定義子菜單進行維護',
    query: '查詢',
    sureDelData: '確認要刪除該數據嗎?',
    tagManage: '頁簽管理',
    tagManageInfo: '對已有的表單數據進行預計算（預處理）, 以備進壹步調用',
    lookAllData: '可見所有關聯數據',
    lookAuthData: '可見數據權限內的數據',
    show: '顯示',
    hidden: '隱藏',
    controlModule: '控制模塊',
    controlContion: '控制條件',
    addRule: '添加規則',
    newBuildRule: '新建規則',
    tabManageMsg1: '請確保所選字段在當前模塊內值不重復,',
    tabManageMsg2: '否則頁簽可能會在數據上出現重復',
    defaultContion: '默認條件',
    showTange: '可見範圍',
    tabStatus: '頁簽狀態',
    dayu: '大於',
    xiaoyu: '小於',
    dayudengyu: '大於等於',
    xiaoyudengyu: '小於等於',
    dengyu: '等於',
    budengyu: '不等於',
    baohan: '包含',
    beibaohan: '被包含',
    bubaohan: '不包含',
    bubeibaohan: '不被包含',
    leijia: '累加',
    koujian: '扣減',
    fixedValue: '固定值',
    dynamicValue: '動態值',
    controlModuleNotEmpty: '控制模塊不能為空',
    controlContionNotEmpty: '控制條件不能為空',
    topSuccess: '置頂成功',
    editRule: '編輯規則',
    tabDelRule: '刪除後該規則控制的模塊將從“自定義模塊名稱”的頁簽上移除?',
    sureTabDelRule: '你確定要刪除選中規則嗎?',
    others: '其他',
    reference: '關聯關系',
    matchAuto: '匹配自動化',
    matchAutoInfo: '通過設定的匹配規則自動獲取符合條件的數據',
    highSeasPool: '公海池',
    oneDayUpperLimit: '每日可領取上限',
    UpperLimit: '領取上限',
    administrators: '管理員',
    secrecyField: '保密字段',
    dontInputInfinite: '不填為無限制',
    addField: '添加字段',
    recoveryRule: '回收規則',
    notRecovery: '不回收',
    recovery: '回收',
    zhixingPinglv: '執行頻率',
    everyday: '每天',
    everyday0clock: '每天0點執行',
    highseaspoolPwd: '可對公海池內的電話和電子郵箱組件做保密控制',
    selectPwdField: '選擇要保密信息的字段',
    inputHighseaspollName: '請填寫公海池名稱',
    memberRequried: '成員必填',
    adminRequried: '管理員必填！',
    highseaspollNameishave: '該公海池名稱已存在',
    limintmax: '領取上限不能小於每日領取上限',
    huishouRequried: '若選擇回收, 則回收規則條件為必填',
    notSeasRule: '非公海池規則',
    returnHighseaspoll: '退回公海池',
    pleaseInputName: '請填寫名稱',
    notSeasRuleIshave: '該非公海池規則已存在',
    recoveryRuleRequried: '回收規則必填',
    returnHighseasRequried: '退回的公海池必填',
    noticePush: '消息推送',
    noticePushInfo: '基於某種條件發送消息提醒指定的成員',
    disable: '禁用',
    enable: '啟用',
    trigger: '觸發動作',
    remindTime: '提醒時間',
    beiRemindPer: '被提醒人',
    remindContent: '提醒內容',
    triggerEvent: '觸發事件',
    anyField: '任意字段',
    zhidingField: '指定字段',
    zhidingFieldSet: '指定字段設置',
    thisDay: '當天',
    before: '之前',
    after: '之後',
    repeatReminder: '重復提醒頻率',
    remindEndtiem: '提醒結束時間',
    remindFangshi: '提醒方式',
    selectShormsgTemplate: '選擇短信模板',
    emailContent: '郵件內容',
    eventHappen: '事件發生時',
    customRemindTime: '自定義提醒時間',
    remindType: '提醒類型',
    remindPinglv: '提醒頻率',
    every: '每',
    day: '天',
    week: '周',
    month: '月',
    year: '年',
    endTime: '結束時間',
    Happen: '發生',
    cizhihou: '次之後',
    result: '結果',
    pushContent: '推送內容',
    selectHappenTrigger: '請選擇編輯數據時觸發提醒的字段',
    neverGameOver: '永不結束',
    cishu: '次數',
    zhidingDate: '指定日期',
    dateTimeField: '日期/時間字段',
    onlyOneRmind: '僅提醒壹次',
    dayRemind: '每天提醒',
    weekRemind: '每周提醒',
    monthRemind: '每月提醒',
    yearRemind: '每年提醒',
    addData: '新增數據',
    receivedNewYaoqing: '收到新的客戶協作邀請',
    never: '永不',
    date: '日期',
    hao: '號',
    themeMustFill: '主題是必填項',
    senderMustFill: '發件人是必填項',
    addresseeeMustFill: '收件人是必填項',
    emailContentMustFill: '郵件內容是必填項',
    pleaseZhidingField: '請選擇指定字段',
    pleaseZhidingTiem: '請選擇提醒時間',
    noticePushMsg1: '提醒時間天數為必填正整數',
    noticePushMsg2: '提醒結束次數為必填正整數',
    noticePushMsg3: '提醒結束指定時間為必填',
    noticePushMsg4: '請選擇提醒結束時間字段',
    noticePushMsg5: '提醒結束時間天數為必填正整數',
    noticePushMsg6: '請添加郵件內容',
    noticePushMsg7: '提醒人不能為空',
    noticePushMsg8: '新增規則成功',
    noticePushMsg9: '刪除規則成功',
    noticePushMsg10: '此操作將禁用該規則, 是否繼續?',
    noticePushMsg11: '此操作將啟用該規則, 是否繼續?',
    everyDay9DontOver: '每1天09:00，不結束',
    maxThreeDate: '最多只能添加三條數據',
    receiveNew: '收到新的',
    receiveShare: '收到共享的',
    benzhuanhuanNewData: '被轉換為新模塊數據',
    receiveTransfer: '收到被轉移的',
    beiDel: '被刪除',
    beiEdit: '數據被修改',
    beiCommon: '被評論',
    quickGenjin: '請及時跟進',
    neverOver: '不結束',
    ciOver: '次結束',
    over: '結束',
    workflowAtuo: '工作流自動化',
    workflowAtuoInfo:
      '將滿足條件的記錄自動執行設定的業務流程; 自動化涉及到字段更新、自動分配、字段轉換、提醒等等',
    start: '開始',
    plus: '加',
    reduce: '減',
    newBuildUpdaInfo: '基於過濾條件對目標模塊進行更新或新建數據操作。',
    operationMode: '操作方式',
    addAndUpdateData: '新建與更新數據',
    updateData: '更新數據',
    isApprovalProcess: '是否發起審批流',
    businessOperation: '業務操作',
    addOperation: '添加操作',
    targetModuleMustfill: '目標模塊為必填項目',
    nameMustfill25: '名稱為必填, 且25個字以內',
    approvalProcessInfo: '發起審批流程中無指定負責人, 請在業務操作中配置負責人對應關系',
    matchCondNotall: '匹配條件不完善',
    filterCondNotall: '過濾條件不完善',
    bussinessOpreationNotall: '業務操作不完善',
    tuijianModule: '推薦模塊',
    updateTime: '更新時間',
    autoMatchCondNotEmpty: '自動化匹配條件不能為空',
    custonBottonInfo: '通過定義當用戶點擊按鈕時執行的操作內容',
    custonBotton: '自定義按鈕',
    name: '名稱',
    buttonName: '按鈕名稱',
    buttonUser: '按鈕使用人員',
    addUserDepRole: '添加成員、部門、角色',
    buttonShowPosition: '按鈕顯示位置',
    buttonShowContion: '按鈕顯示條件',
    AlwaysShow: '總是顯示',
    thisCotntionShow: '滿足以下條件時顯示',
    clickButtonShowPop: '點擊按鈕後是否需要彈窗填寫內容：',
    noNeed: '不需要',
    need: '需要',
    customButtonTips: '提示文字（提示文字為空則代表無須彈窗提示，直接執行後續規則）',
    determineNeedTriggeContent: '確認後需要觸發更新內容',
    detailsPage: '詳情頁面',
    listPage: '列表頁面',
    addNoduleData: '新增模塊數據',
    fieldUpdateTrigge: '字段更新-觸發後臺規則',
    openUrl: '跳轉鏈接',
    initiateApproval: '發起審批',
    pleaseInputButtonName: '請填寫按鈕名稱',
    pleaseSelectButtonUser: '請選擇按鈕使用人員',
    pleaseSelectButtonPostion: '請選擇按鈕顯示位置',
    popSelectOneFiled: '彈窗中最少選擇壹個字段',
    pleaseSelectTriggeModule: '請選擇目標模塊',
    pleaseSelectJumpSystem: '請填寫跳轉鏈接',
    roleAuth: '角色權限',
    pageAuth: '頁面權限',
    fieldDependent: '字段依賴',
    optioneFieldControl: '選項字段控制',
    recordStyle: '記錄樣式',
    highSeasManage: '公海管理',
    notHighSeasRule: '非公海規則',
    externalLinks: '外部鏈接',
    viewManage: '視圖管理',
    checkRepeatSettings: '查重設置',
    // 2020-10-30
    checkRepeatInfo: '通過復雜查重規則，排除人為操作出現的重復信息',
    dongtaiTime1: '動態時分-提前',
    dongtaiTime2: '動態時分-延後',
    wechatNoticeInfo:
      '該方式僅針對綁定了微信公眾號的員工生效，未綁定微信公眾號員工無法收到消息推送，如需綁定微信公眾號請至【系統管理】-【系統管理】下的微信公眾號訪問中配置',
    fenbieSend: '分別發送',
    teshuMember: '特殊成員',
    teshuMember1: '特殊成員領取上限',
    teshuMember2: '特殊成員每日領取上限',
    teshuMember3: '領取限制',
    teshuMember4: '說明：數據被退回或者系統定時回收公海池後，前負責人在N天後不能領取。',
    teshuMember5: '天內不能連續領取同壹條數據',
    highseaJudge1: '成員領取上限為正整數',
    highseaJudge2: '成員每日可領取上限為正整數',
    highseaJudge3: '特殊成員領取上限為正整數',
    highseaJudge4: '特殊成員每日領取上限為正整數',
    highseaJudge5: '領取限制為正整數',
    highseaJudge6: '特殊成員領取上限不能小於特殊成員每日領取上限',
    highseaJudge7: '領取限制最大輸入值100',

    // 2020-12-25
    searchTargetModuleUpdate: '查詢目標模塊數據後更新到本模塊中',
    emailTemplateSet: '郵件提醒模板',
    emailContentRemind: '郵件提醒內容',
    referenceYilaiInfoNew:
      '應用於為“關聯關系”、“部門-單選”類型的字段, 實現兩個關聯關系之間、兩個部門之間的數據過濾',
    gobackBusinessFlow: '返回企業工作流',
    BusinessFlowSet: '企業工作流設置',
    scheduleDataInfo1: '日程/待辦任務組件呈現事件/執行人設置',
    scheduleDataInfo2: '日程/待辦任務組件完成狀態設置，完成的數據將劃線標記為已完成任務',
    scheduleDataInfo3: '日程/待辦任務卡片顯示字段設置',
    scheduleDataInfo4: '根據表單數據推送到門戶：日程/待辦任務 不允許創建多個',
    scheduleDataInfo5: '日程/待辦任務組件完成狀態設置有誤',

    // 2021-04-08
    everyMinute: '每分鐘',
    triggerTiming: '觸發定時',
    breakTimeTrigger: '在休息時間定時觸發關閉',
    offDutyDay: '不上班工作日',
    offHours: '不上班時間段',
    noonBreak: '中午休息時間段',
    offHolidays: '法定節假日定時觸發關閉',
    selectOffDutyDay: '請選擇不上班工作日',
    selectOffHours: '請選擇不上班時間段',
    selectNoonBreak: '請選擇中午休息時間段',
    btnColor: '按鈕顏色',
    smartPlugInfo:
      '使用該功能前請至【接口集成】--【第三方平臺】--【阿裏雲集成】中設置對應阿裏雲接口帳戶。',
    smartPlugTitle:
      '使用該功能，請先去【接口集成】菜單-【第三方平臺】對應頁簽中進行設置，設置後才可使用',
    idCardShibie: '身份證實名識別',
    businessInfoSearch: '工商信息查詢',
    sureCloseAndClear: '確定要關閉嗎？關閉後字段設置將被清空',
    idCardRequired: '身份證信息必填',
    companyNameRequired: '企業名稱必填',
    payFieldRequired: '支付字段必填',
    namePictureIdcard: '圖片+姓名+身份證實名識別',
    verifyPictureNameIDcard: '用於校驗圖片、姓名和身份證號是否匹配，必填。',
    mapModeSettings: '地圖模式設置',
    mapMode: '地圖模式',
    showTabModule: '顯示頁簽模塊',
    mapModeSettingsTips:
      '用於在定位地圖下，顯示其它頁簽模塊的數量以及支持點擊數量查看列表，比如客戶下的聯系人。',
    selectTabModule: '選擇頁簽模塊',
    SubordinateTheStage: '所屬階段',
    mapModeTip1: '定位地圖功能有必填項未填寫',
    mapModeTip2: '顯示頁簽模塊有必填項未填寫',
    deleteSchedule: '刪除日程',
    deleteDataTriggerAdd: '刪除當前數據觸發的新建日程',
    deleteScheduleRequired: '刪除日程必填',
    constFieldRequired: '常量字段必填',
    oprationPaymentSetTip: '執行操作【賬期設置】的觸發事件必須是【在新建記錄保存後】',
    PaymentDaysSet: '賬期設置'
  }
}
